import { memo } from 'react';
import { DateTimeUtils, LocalizedLongDate, useTimezone } from '@mews/framework';
import { LocalizedUtcComponentProps } from './types';

export const LocalizedUtcLongDate = memo(({ utcString, dataTestId }: LocalizedUtcComponentProps) => {
    const timezone = useTimezone();
    const date = DateTimeUtils.dateTimeUtcStringToDate(utcString, timezone);

    return <LocalizedLongDate date={date} data-test-id={dataTestId} />;
});
